import React from 'react';
import { TertiaryButton } from '@mlc/web-ui-toolkit';

type Props = {
	id: string;
	label: string;
	isActive: boolean;
	handler: () => any;
	forwardedRef?: any;
};

const ActionLink = ({ isActive, handler, id, label, forwardedRef }: Props) =>
	isActive == true ? (
		<div key="editDiv" className="veEdit">
			<TertiaryButton
				key={id}
				onClick={handler}
				aria-label={label}
				ref={forwardedRef}
			>
				Edit
			</TertiaryButton>
		</div>
	) : (
		<div
			key="emptyDiv"
			style={{ marginLeft: '20px', maxWidth: '40px', textAlign: 'right' }}
		/>
	);

export default ActionLink;
